import { defa, T }        from 'defa-object';
import { executePlugins } from 'execute-plugins';
import UserProfileService from 'user-profile';

import AlarmCentralsModule        from 'scripts/defa/alarm-centrals/module-alarm-centrals';
import AlarmGroupsModule          from 'scripts/defa/alarm-groups/module-alarm-groups';
import Link                       from 'scripts/defa/application/application-link';
import ApplicationModule          from 'scripts/defa/application/module-application';
import BehaviorModule             from 'scripts/defa/behaviors/module-behaviors';
import ControlsModule             from 'scripts/defa/control/module-controls';
import CustomerModule             from 'scripts/defa/customers/module-customers';
import InsuranceCompaniesModule   from 'scripts/defa/insurance-companies/module-insurance-companies';
import InvitationModule           from 'scripts/defa/invitations/module-invitation';
import InvoiceModule              from 'scripts/defa/invoices/module-invoices';
import LegacyModule               from 'scripts/defa/legacy/module-legacy';
import LogModule                  from 'scripts/defa/log/module-log';
import AccessoriesModule          from 'scripts/defa/control/accessories-holder/accessories/module-accessories';
import NotificationsModule        from 'scripts/defa/notifications/module-notifications';
import PhoneNumberModule          from 'scripts/defa/phone-numbers/module-phone-numbers';
import RecipientsModule           from 'scripts/defa/recipients/module-recipient';
import RoleApplicationsModule     from 'scripts/defa/role-applications/module-role-applications'
import SearchResultModule         from 'scripts/defa/search-results/module-search-results';
import SettingsAutomotiveModule   from 'scripts/defa/settings-automotive/module-settings-automotive';
import SubscriptionPackagesModule from 'scripts/defa/subscription-packages/module-subscription-packages';
import SubscriptionsModule        from 'scripts/defa/subscriptions/module-subscriptions';
import SupportModule              from 'scripts/defa/support/module-support';
import TermsAndConditionsModule   from 'scripts/defa/terms-and-conditions/module-terms-and-conditions';
import UnitFeatureSetModule       from 'scripts/defa/unit-feature-sets/module-unit-feature-set';
import UnitTestsModule            from 'scripts/defa/unit-tests/module-unit-tests';
import UnitsModule                from 'scripts/defa/units/module-units';
import UserModule                 from 'scripts/defa/users/module-users';
import WeatherModule              from 'scripts/defa/weather/module-weather';
import ZonesModule                from 'scripts/defa/zones/module-zones';
import ActiveHeader               from 'scripts/plugins/activeheader';
import LanguageSelector           from 'scripts/plugins/language-selector';
import LanguageSettings           from 'scripts/plugins/language-settings';

import 'thirdparty/jquery';

// expose jQuery, Marionette, Backbone and Underscore to the window.
Object.assign( window, { $, Mn, Bb, _ } );

// the DOM is loaded, init the application.
document.addEventListener( 'DOMContentLoaded', () => {
	
	// noinspection JSUnresolvedVariable
	window.defa = defa;
	
	// checks for android/webkit/toyota objects and apply correct settings.
	defa.setInternalEnvironment();
	
	// init plugins
	executePlugins( $ );
	
	// moved much of what was here to the execute-plugins above.
	
	// this doesn't need to be set first, the behaviorLookup should happen in Link->before:start.
	//defa.registerModule( BehaviorModule );
	//Mn.Behaviors.behaviorsLookup = function () {
	//	return defa.behaviors;
	//};
	
	// attach i18n to the template renderer, does not need to happen before Link->before:start
	//Mn.View.setRenderer( ( template, data ) => {
	//	return Mn.Renderer.render( template, Object.assign( data, { i18n: T } ) );
	//} );
	
	// init the Waves plugin
	//Waves.init();
	
	// setup the format function of the Date object with i18n.
	//setupDateFormat();
	
	// setup the analytics snippet
	//setupAnalytics();
	
	
	// Note: Historically, getting the first userdata was done before delivering the html to
	//       the end user, and the data was appended to the defa.vars before the body was delivered.
	//       That way we'd avoid having to use another http-request to get data we'd always need
	//       to init the app anyways.
	//       The current solution for webpack is definitely not optimal.
	//
	//       !TODO: Find a more optimal way of fetching userdata.
	
	// set temp language by localStorage, IEOnly variable, browser variable.
	let tempLang = localStorage.lang || window.navigator.userLanguage || window.navigator.language;

	let userFuture;
	//Check if app-version has login
	if ( defa.vars.toyota ) {
		userFuture = UserProfileService.populateForApp( tempLang );
	} else {
		userFuture = UserProfileService.populateFromAPI( tempLang );
	}

	userFuture
		.then( () => {
			
			// we expect the native application to push their data at the init of the webview instance,
			// which means the language parameter should be set by the app by now if it exists.
			// if not, we fallback to the tempLang.
			defa.objects.languageSettings = new LanguageSettings( defa.vars.user && defa.vars.user.language ? defa.vars.user.language : tempLang );
			return T.setLanguage( defa.objects.languageSettings.lang );
		} )
		.then( () => {
			
			// translate all vars
			T.translateHtml();
			
			// register all the application modules
			defa.registerModules( [
				BehaviorModule,
				UserModule,
				CustomerModule,
				PhoneNumberModule,
				InvoiceModule,
				ApplicationModule,
				ZonesModule,
				UnitsModule,
				UnitTestsModule,
				SettingsAutomotiveModule,
				SearchResultModule,
				AlarmCentralsModule,
				AlarmGroupsModule,
				InsuranceCompaniesModule,
				InvitationModule,
				LogModule,
				SubscriptionsModule,
				SubscriptionPackagesModule,
				TermsAndConditionsModule,
				ControlsModule,
				SupportModule,
				UnitFeatureSetModule,
				LegacyModule,
				WeatherModule,
				NotificationsModule,
				RecipientsModule,
				RoleApplicationsModule,
				AccessoriesModule,
			] );
			
			// init language menu, dynamic header, and finally initialize the actual Link application.
			defa.objects.languageSelector = new LanguageSelector();
			defa.objects.activeHeader     = new ActiveHeader();
			defa.objects.app              = new Link();
		} )
		.catch( err => {
			// print the error on screen and in the console.
			console.error( err );
			
			let message  = messageForError( err );
			let feedback = '<p class="danger"><strong>%1s</strong> - %2s</p>'
				.replace( '%1s', message.title || 'Error' )
				.replace( '%2s', message.message );
			
			$( '#main' ).html( feedback );
		} );
} );

/**
 * Add ErrorObject for ConnectionErrors as well.
 * @param   err     Error An Error object.
 * @returns object  An object with a title string and a message string describing the error
 */
function messageForError( err ) {
	switch ( err.name ) {
		case 'ConnectionError':
			return {
				title  : T.tc( 'Error', 'Connection error' ),
				message: T.tc( 'Error', 'Could not connect to server. Please verify your connection and try again.' ),
			};
	}
	return { title: err.title || '', message: err.message || '' };
}
